import React, { useEffect, useState } from 'react';
import HeaderV2 from '../../components/v2/HeaderV2';
import FooterV2 from '../../components/v2/FooterV2';
import ServicesHeroV2 from '../../components/v2/ServicesHeroV2';
import ServicesGridSectionV2 from '../../components/v2/ServicesGridSectionV2';
import ProcessStripCompactV2 from '../../components/v2/ProcessStripCompactV2';
import AuditCTABannerV2 from '../../components/v2/AuditCTABannerV2';
import { getPublishedServices } from '../../services/v2ServicesRepository';
import useV2Language from '../../hooks/useV2Language';
import useDocumentLanguage from '../../hooks/useDocumentLanguage';
import '../../styles/v2/tokens.css';
import '../../styles/v2/landing.css';
import '../../styles/v2/services.css';

const PAGE_TITLES = { en: 'Services — illumi.dev', es: 'Servicios — illumi.dev' };

const ServicesV2 = () => {
  const { lang, setLang, buildHref } = useV2Language();
  useDocumentLanguage(lang);
  const [state, setState] = useState({ status: 'loading', data: [], error: '' });

  useEffect(() => {
    document.title = PAGE_TITLES[lang] || PAGE_TITLES.en;
  }, [lang]);

  useEffect(() => {
    let alive = true;
    setState((s) => ({ ...s, status: 'loading', error: '' }));
    getPublishedServices({ lang })
      .then((data) => {
        if (!alive) return;
        setState({ status: 'success', data, error: '' });
      })
      .catch((exc) => {
        if (!alive) return;
        setState({
          status: 'error',
          data: [],
          error: (exc && exc.message) || 'Could not load services.',
        });
      });
    return () => {
      alive = false;
    };
  }, [lang]);

  const t = PAGE_TITLES;
  void t;

  return (
    <div className="illumi-v2" data-testid="illumi-v2-services">
      <HeaderV2 language={lang} onLanguageChange={setLang} buildHref={buildHref} />

      <main>
        <ServicesHeroV2 lang={lang} />

        {state.status === 'loading' && (
          <div className="iv2-services-status iv2-container" role="status" data-testid="iv2-services-loading">
            {lang === 'es' ? 'Cargando…' : 'Loading…'}
          </div>
        )}

        {state.status === 'error' && (
          <div className="iv2-services-status iv2-container" role="alert" data-testid="iv2-services-error">
            {state.error}
          </div>
        )}

        {state.status === 'success' && state.data.length === 0 && (
          <div className="iv2-services-status iv2-container" role="status" data-testid="iv2-services-empty">
            {lang === 'es' ? 'No hay servicios publicados por el momento.' : 'No services are published yet.'}
          </div>
        )}

        {state.status === 'success' && state.data.length > 0 && (
          <>
            <ServicesGridSectionV2 services={state.data} lang={lang} />
            <ProcessStripCompactV2 lang={lang} />
            <AuditCTABannerV2 lang={lang} />
          </>
        )}
      </main>
      <FooterV2 language={lang} buildHref={buildHref} />
    </div>
  );
};

export default ServicesV2;
